module.exports = __webpack_public_path__ + "img/icon_documents.e1b7696f.svg";